module.exports = __webpack_public_path__ + "img/pr-4.3a0a8caa.png";